module.exports = __webpack_public_path__ + "img/icon-facebook - w.5666cf7d.svg";